import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { ArrowVectorRight } from 'src/components/icons/ArrowVectorRight'
import Link from 'src/components/ui/Link'

import ShopServiceDesktop from './ShopServiceDesktop'
import ShopServiceMobile from './ShopServiceMobile'
import type { ShopServicesProps } from './shop-services'
import './shopServices.scss'

const ShopServices = ({ desktop, mobile }: ShopServicesProps) => {
  const { isMobile } = useBreakpoint()

  const { title, text, href } = isMobile ? mobile : desktop

  return (
    <section className="page-services">
      <div className="page-services-container">
        <div className="page-services-container-text">
          <h2 className="page-services-container-text__title">{title}</h2>
          {text ? (
            <Link
              className="page-services-container-text__link"
              as="a"
              href={href}
            >
              {text}

              <ArrowVectorRight
                className="page-services-container-text__icon"
                width={5}
                height={8}
              />
            </Link>
          ) : (
            ''
          )}
        </div>
        {isMobile ? (
          <ShopServiceMobile sources={mobile.sources} />
        ) : (
          <ShopServiceDesktop sources={desktop.sources} />
        )}
      </div>
    </section>
  )
}

export default ShopServices
